// CSS Modules - component class name: Select__

<template>
<div :class="[
  { Select__blue: colour === 'blue' },
  { Select__white: colour === 'white' },
  $style.select
]">
  <multiselect
    v-model="value"
    :options="options"
    :searchable="false"
    :show-labels="false"
    :trackBy="trackBy"
    :label="label"
    :placeholder="placeholder"
    :allow-empty="false"
    :index="index"
  ></multiselect>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: "Select",
  components: { Multiselect },
  props: {
    colour: {
      type: String,
      default: "blue"
    },
    selectValue: {
      type: String,
      default: ""
    },
    selectOptions: {
      type: Array,
      default () {return ['']}
    },
    selectIndex: {
      type: String,
      default: "",
    },
    trackBy: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      value: this.selectValue,
      options: this.selectOptions,
      index: this.selectIndex
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("onChange", newValue);
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style module lang="scss">
@import "./Select.scss";
</style>
